import { useMemo } from 'react';
import { ChecklistCategory, ChecklistItemOverview } from '../../types/checklist';

type CategoriseChecklistItems = {
    categoryId?: string;
    categoryName: string;
    checklistItems: ChecklistItemOverview[];
};

export function useCategoriseChecklistItems(
    categories: Omit<ChecklistCategory, 'checklistId'>[] | ChecklistCategory[],
    checklistItems: ChecklistItemOverview[]
): CategoriseChecklistItems[] {
    const categoriseChecklistItems = useMemo(() => {
        let categoryGroups: CategoriseChecklistItems[] = [];
        for (const category of categories) {
            const items = checklistItems.filter((c) => c.categoryId === category.id);
            categoryGroups.push({ categoryId: category.id, categoryName: category.name, checklistItems: items });
        }

        // Sort categories by name alphabetically
        categoryGroups = categoryGroups.sort((a, b) => (a.categoryName > b.categoryName ? 1 : -1));

        // Push uncategorised checklist items in 'Other' checklist category
        const otherChecklistItems = checklistItems.filter((c) => c.categoryId === undefined);
        if (otherChecklistItems.length > 0) {
            categoryGroups.push({ categoryId: undefined, categoryName: 'Other', checklistItems: otherChecklistItems });
        }

        return categoryGroups;
    }, [categories, checklistItems]);

    return categoriseChecklistItems;
}
